//NoRecordsFound.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as NoRecordsFound from "./NoRecordsFound";

import { Typography } from "@mui/material";
import { yellow } from '@mui/material/colors';

import React from "react";

export let msg: string = "";
let showRef: (message: string) => void; //Ref to showIt method inside render.

export function setMsg(message: string): void {
   if (showRef) {
      showRef(message);
   }
}

//Render function.
export function Render() {

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   function showIt(message: string) {
      if (message) {
         msg = message;
         refresh();
      }
   }

   const showRef2 = React.useRef(showIt);

   //Component did mount. Set module level variables.
   React.useEffect(() => {
      showRef = showRef2.current;
   }, []);

   //Component did update. Reset the module level defaults in case they were changed by calling arguments.
   React.useEffect(() => {
      msg = "";
   });

   const styles: Default.iStyles = {
      errMsg: { backgroundColor: yellow[500], marginTop: 10, marginLeft: 4, marginRight: 9, padding: 3, paddingLeft: 7 },
   };

   if (NoRecordsFound.msg === "") {
      return (<div />);

   } else {
      return (
         <Typography variant="body1" style={styles.errMsg}>
            {NoRecordsFound.msg}
         </Typography>
      );
   }

} //end function.
